/**
 * @file 产品详情板块
 * @author Wence
 */

import {rcAjax} from '../util';
import {
    GET_CMSAPI_PRODUCT_DETAIL_INDEX,
    GET_CMSAPI_PRODUCT_DETAIL_LIST,
    GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST
} from './ActionTypes';

const isError = res => res && res.data && res.data.is_error === 0;

export const fetchProductDetailIndexData = params => dispatch =>
    rcAjax('GET', '/cmsapi/getProductSegmentData', params, {}, res => {
        dispatch({type: GET_CMSAPI_PRODUCT_DETAIL_INDEX, data: isError(res) ? res.data : {}});
    });

export const fetchProductDetailList = (params, isMore) => dispatch =>
    rcAjax('GET', '/cmsapi/productTagData', params, {}, res => {
        const articleList = 'article_list';

        isMore
            ? dispatch({
                type: GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST,
                data: isError(res) ? res.data : {itemlist: {[articleList]: {datalist: []}}}
            })
            : dispatch({
                type: GET_CMSAPI_PRODUCT_DETAIL_LIST,
                data: isError(res) ? res.data : {}
            });
    });



// WEBPACK FOOTER //
// ./src/actions/productDetailAction.js